import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const AssignRoleAPISlice = createApi({
  reducerPath: "assignRoleApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    assignRole: builder.mutation({
      query: (data) => ({
        url: "/rbac/roles/multiple/assign",
        method: "POST",
        body: data
      }),
      extraOptions: { service: "Utility" }
    }),
    removeRole: builder.mutation({
      query: ({ userIds, roleId }) => ({
        url: `/rbac/delete/assigned/${roleId}`,
        method: "PUT",
        body: { userIds: [userIds] }
      }),
      extraOptions: { service: "Utility" }
    }),
    getRole: builder.query({
      query: (roleId) => ({
        url: `/rbac/roles/${roleId}`,
        method: "GET"
      }),
      extraOptions: { service: "Utility" }
    }),
    updateRole: builder.mutation({
      query: ({ userId, expiry, active, roleId }) => ({
        url: `/rbac/update/${roleId}`,
        method: "POST",
        body: [
          {
            userId,
            expiry,
            active
          }
        ]
      }),
      extraOptions: { service: "Utility" }
    })
  })
});

export const {
  useAssignRoleMutation,
  useRemoveRoleMutation,
  useGetRoleQuery,
  useLazyGetRoleQuery,
  useUpdateRoleMutation
} = AssignRoleAPISlice;
